

















export default {
  name: 'newsletter-signup'
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/generic/NewsletterSignup.vue